import { Component, OnInit } from '@angular/core';
import { AuthenService } from '../../../services/Authen/authen.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private AuthenService: AuthenService,
    private router: Router
  ) { }

  Username: any;
  Password: any;
  auth_data: any;

  ngOnInit(): void {
    this.verify_auth(JSON.parse(localStorage.getItem("access_token")))
  }

  Login() {
    this.AuthenService.Login(this.Username, this.Password).subscribe(
      response => {
        localStorage.setItem("access_token", JSON.stringify(response));
        this.verify_auth(response);
      },
      error => {
        Swal.fire({
          icon: 'error',
          title: 'ผิดพลาด',
          text: 'โปรดตรวจสอบ ID หรือ Password'
        })
      }
    )
  }

  verify_auth(data){
    if (data) {
      window.location.href = "./#/";
      // switch (data.role) {
      //   case 'Admin':
      //     window.location.href = "./#/user-management";
      //     break;
      
      //   default:
      //     window.location.href = "./#/";
      //     break;
      // }
    } 
  }
}
